<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1.titulo(v-if="!processo") Ajustar Processo
    div.box-titulo(v-else)
      el-button.botao-voltar(
        type="primary"
        @click="voltar"
      )
        span.center
          i.fas.fa-chevron-left
      span.span-titulo(v-if="processo") {{ `Processo ${numProcesso}:` }}
    el-row.caixa-pesquisa(:gutter="30", v-if="!processo")
      el-col(:span="8")
        app-label(label="Digite o N° do Processo:")
        el-input(
          placeholder="N° do Processo",
          class="input-with-select",
          v-model="numProcesso"
        )
          el-button.color-default(
            slot="append",
            icon="el-icon-search",
            id='botao-pesquisar',
            @click="pesquisar"
          )
    el-row.caixa-pesquisa(:gutter="30", v-else)
        card-processo(
          :idProcesso="processo.id",
          :nomeInteressado="processo.nomeRazaoSocialInteressado",
          :statusProcesso="processo.status",
          :numeroProcesso="processo.numeroProcesso",
          :cpfCnpjInteressado="processo.cpfCnpjInteressado",
          :setorProcesso="processo.setor",
          :opcoesAcoes="true",
          :numeroProtocolo="processo.numeroProtocolo",
          :tipoCodigoProcesso="processo.tipo.codigo",
          :usuario="processo.usuario"
        )
        div.mover-processo
          div
            app-label(label="Ajustar Processo:", style="margin-top: 20px")
            el-select.select(
              placeholder="Selecione a caixa",
              class="input-with-select",
              v-model="acao",
              class="select"
            )
              el-option(
                v-for="servico in acoes",
                :key="servico.codigo",
                :label="servico.nome",
                :value="servico.codigo"
              )
            el-button(
              type="primary"
              @click="ajustarProcesso"
            )
              span.center
                b Ajustar Processo &nbsp
                i.fas.fa-chevron-right
</template>

<script>
import { parseString } from 'xml2js'
import AppLabel from '@/components/AppLabel'
import { buscarProcesso, getXmlFluxo, regerarCertidaoQuitacao, gerarNovoDaeAutomaticoGacVencido, retornaProcessoFluxoForaMonitoramento, startProcessoFluxoMonitoramento, erro404 } from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CardProcesso from './components/CardProcesso.vue'

export default {
  components: {
    AppLabel,
    CardProcesso
  },
  data () {
    return {
      numProcesso: '',
      acoes: [
        { codigo: 'REGERAR_CERTIDAO', nome: 'Regerar Certidão de Quitação' },
        { codigo: 'GERAR_NOVO_DAE', nome: 'Gerar novo DAE automático com GAC vencido' },
        { codigo: 'STARTAR_PROCESSO', nome: 'Startar processo no fluxo de monitoramento' },
        { codigo: 'RETORNAR_PROCESSO', nome: 'Retornar processo fora de monitoramento' },
        { codigo: 'ERRO_404', nome: 'Ajustar erro 404' }
      ],
      acao: null,
      processo: null,
      setoresFluxo: null
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    async pesquisar () {
      if (!this.numProcesso || this.numProcesso === '') {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      } else {
        try {
          const response = await buscarProcesso(this.numProcesso)
          if (response) {
            this.processo = response
            const { xml } = await getXmlFluxo(response.numeroProcesso, response.tipo.codigo)
            if (xml) {
              parseString(xml, (_, results) => {
                this.setoresFluxo = results.definitions.process[0].callActivity.map(o => ({
                  nome: o['$'].name,
                  acao: o['$'].id
                })).filter(e => !e.acao.includes('INICIAR'))
              })
            } else {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao obter o XML do fluxo')
            }
          } else {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar o Processo, verifique o N° do Processo')
          }
        } catch (error) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar o Processo: ' + error.message)
        }
      }
    },

    async ajustarProcesso () {
      if (!this.acao || !this.processo) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione uma ação')
        return
      }

      try {
        let response
        switch (this.acao) {
          case 'REGERAR_CERTIDAO':
            response = await regerarCertidaoQuitacao(this.processo.id)
            break
          case 'GERAR_NOVO_DAE':
            response = await gerarNovoDaeAutomaticoGacVencido(this.processo.id)
            break
          case 'STARTAR_PROCESSO':
            response = await startProcessoFluxoMonitoramento(this.processo.id)
            break
          case 'RETORNAR_PROCESSO':
            response = await retornaProcessoFluxoForaMonitoramento(this.processo.id)
            break
          case 'ERRO_404':
            response = await erro404(this.processo.id)
            break
        }

        if (response) {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo ajustado com sucesso')
        } else {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao ajustar o processo')
        }
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao ajustar o processo: ' + error.message)
      }
    },

    voltar () {
      this.processo = null
      this.setoresFluxo = null
      this.numProcesso = ''
    }
  }
}
</script>

<style lang="scss" scoped>
$font-size-small: 12px;
.color-default {
  color: #009d64 !important;
  font-size: 16px;
}
.caixa-pesquisa {
  margin-bottom: 10px;
}
.titulo {
  margin-top: 0;
}
.span-titulo {
  margin-top: 0;
  margin-bottom: 3px;
  font-size: 32px;
  margin-left: 20px;
}
.box-processo {
  min-width: 700px;
  padding-left: 3px;
  padding-right: 3px;
}
.select {
  margin-right: 20px;
  inline-size: 50em;
}
.span-style {
  font-weight: normal;
}
.botao-voltar {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.center {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.box-titulo {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.col-principal {
  width: 100%;
  min-width: 685px;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/AjustarProcessos.vue